import { Component, OnInit, AfterViewInit, Inject } from '@angular/core'
import { BillingService } from '../store/billing/billing.service'
import { map, switchMap } from 'rxjs/operators'
import { StripeBillingDetails, StripeAPIError } from './stripe.model'
import { from, Observable } from 'rxjs'
import { ENVIRONMENT } from '@tokeet-frontend/tv3-platform'

const cardElementId = 0

@Component({
  selector: 'app-stripe-credit-card-form',
  templateUrl: './stripe-credit-card-form.component.html',
})
export class StripeCreditCardFormComponent implements OnInit, AfterViewInit {
  stripe: any
  stripeCardElement: any

  cardElementId = cardElementId + 1

  cardValidationMessage = ''
  isCardValid = false
  constructor(private billingService: BillingService, @Inject(ENVIRONMENT) private environment: any) {}

  ngAfterViewInit(): void {
    this.stripeCardElement.mount(`#card-element-${this.cardElementId}`)
  }

  ngOnInit(): void {
    // @ts-ignore
    this.stripe = Stripe(this.environment.config.stripe_publishable_key)
    this.stripeCardElement = this.stripe.elements().create('card', {
      style: {
        base: {
          iconColor: '#666EE8',
          color: '#31325F',
          lineHeight: '40px',
          fontWeight: 300,
          fontFamily: '"Poppins", Open Sans, Segoe UI, sans-serif',
          fontSize: '15px',
          '::placeholder': {
            color: '#757575',
          },
        },
      },
    })
    this.stripeCardElement.on('change', (event) => {
      this.cardValidationMessage = event.error?.message || ''
      this.isCardValid = event.complete
    })
  }

  private setupIntent() {
    return this.billingService.setupIntent()
  }

  handleCardSetup(details: StripeBillingDetails) {
    return this.setupIntent().pipe(
      switchMap(
        (response) =>
          from(
            this.stripe.handleCardSetup(response.client_secret, this.stripeCardElement, {
              payment_method_data: {
                billing_details: details,
              },
            })
          ) as Observable<{ setupIntent: any; error: StripeAPIError }>
      ),
      map((response) => {
        if (response.error) {
          throw response.error
        }
        return response.setupIntent
      })
    )
  }
}
